var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#0071B3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3863_175838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0194 19.0787L22.8747 21.9333L21.9314 22.8767L19.0767 20.0213C18.0145 20.8728 16.6934 21.3359 15.332 21.334C12.02 21.334 9.33203 18.646 9.33203 15.334C9.33203 12.022 12.02 9.33398 15.332 9.33398C18.644 9.33398 21.332 12.022 21.332 15.334C21.334 16.6953 20.8708 18.0165 20.0194 19.0787ZM18.682 18.584C19.5281 17.7139 20.0006 16.5476 19.9987 15.334C19.9987 12.7553 17.91 10.6673 15.332 10.6673C12.7534 10.6673 10.6654 12.7553 10.6654 15.334C10.6654 17.912 12.7534 20.0007 15.332 20.0007C16.5457 20.0026 17.712 19.5301 18.582 18.684L18.682 18.584Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3863_175838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.d093cc87136cfe1d7a715841d3138a0a.svg";
export { ForwardRef as ReactComponent };